import React from "react";
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";

export default function AdminProtected({ children, roles }) {
  const { admin, loading } = useAdminAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "#070707" }}>
        <span className="inline-block w-3 h-3 rounded-full bg-[#4CAF50] dot-pulse" />
      </div>
    );
  }
  if (!admin) return <Navigate to="/admin/login" replace />;
  if (roles && !roles.includes(admin.role) && admin.role !== "super_admin") {
    return (
      <div className="p-10 text-center">
        <p className="text-white/60">You don't have permission to view this page.</p>
      </div>
    );
  }
  return children;
}
